import React from 'react';
import classNames from 'classnames';
import { truncateString } from 'js-utils/string';
import { EVENT_TITLE_MAX_LENGTH } from './constants';

var FormattedEventName = function FormattedEventName(_ref) {
  var eventName = _ref.eventName,
      isConsumer = _ref.isConsumer;
  var clampedClassNames = classNames('eds-event-card__formatted-name--is-clamped', {
    'eds-event-card__formatted-name--is-clamped-three eds-text-weight--heavy': isConsumer
  });
  return React.createElement("div", {
    "data-spec": "event-card__formatted-name"
  }, React.createElement("div", {
    className: "eds-is-hidden-accessible"
  }, eventName), React.createElement("div", {
    className: clampedClassNames,
    "aria-hidden": "true",
    role: "presentation",
    "data-spec": "event-card__formatted-name--content"
  }, truncateString(eventName, EVENT_TITLE_MAX_LENGTH)));
};

export default FormattedEventName;